$(document).ready(function() {
  // Listen for input in the search bar
  $("#searchInput").on("keyup", function() {
    var value = $(this).val().toLowerCase(); // Get the search term and convert to lowercase

    // Loop through each row in the table
    $("#AssociationBenefitsTable .association-row").filter(function() {
      // Toggle visibility based on whether the row's name matches the search term
      $(this).toggle($(this).find("td:nth-child(3)").text().toLowerCase().indexOf(value) > -1);
    });
  });
});